// extracted by mini-css-extract-plugin
export default {"today":"today-button_today__F3iOB","available":"today-button_available__RnAds"};